import React from "react"
import { Block, Spacer } from "../../atoms/layout-primitives"
import { BlogGrid } from "../../atoms/layout-primitives/grid"
import Pagination from "../../molecules/pagination"

interface IListingPaginationProps {
  currentPage: number
  totalPages: number
  pagePrefix: string
}

/**
 * Template for the pagination at the bottom of a listing page
 * @param currentPage - the current page
 * @param totalPages - the total number of pages
 * @param pagePrefix - the prefix for the page url
 */
const ListingPagination = (props: IListingPaginationProps) => {
  return (
    <BlogGrid>
      <Block>
        <Pagination {...props} />
        <Spacer height={{ sm: "48px", lg: "64px" }} />
      </Block>
    </BlogGrid>
  )
}

export default ListingPagination
